module.exports = __webpack_public_path__ + "media/images/securite-587511c03a0346570d341f4cffac4f12.svg";